<fn-modal-header class="modal-header">
    <h5 class="modal-title" mat-dialog-title>All Resolved</h5>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </fn-modal-header>
  <mat-dialog-content class="p-15">
    <div class="row">
      <div class="col-12 mt-10">
        <div class="row">
          <div class="col-2">
            <div class="">
              <label>Telegram</label>
              <fn-checkbox
                [(ngModel)]="isSendTelegram"
                (change)="selectionCheck($event)"
                [value]=""
              ></fn-checkbox>
            </div>
          </div>
          <div class="col-8">
            <textarea
              class="form-control commentArea"
              placeholder="Add your comment here..."
              [(ngModel)]="commentObject.textComment"
            ></textarea>
          </div>
          <div class="col-2 d-flex align-items-center">
            <button
              ngcontent-bfp-c244=""
              (click)="addComment()"
              class="commentSend-btn btn-link btn"
            ><i class="fn-global-send white font-35"></i></button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  
